import { FC, CSSProperties, ReactNode, MouseEvent } from 'react'
import { noop } from 'lodash-es'

type LinkProps = {
  href: string
  className?: string
  target?: string
  rel?: string
  title?: string
  style?: CSSProperties
  hint?: string
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void
  method?: string
  children?: ReactNode
  ariaLabel?: string
}

const Link: FC<LinkProps> = ({
  href,
  onClick = noop,
  className,
  target,
  title,
  hint,
  style,
  method,
  rel,
  ariaLabel,
  children,
}) => {
  return (
    <a
      href={href}
      onClick={onClick}
      className={className}
      style={style}
      target={target}
      title={title}
      aria-label={ariaLabel}
      data-hint={hint}
      data-method={method}
      rel={rel}
    >
      {children}
    </a>
  )
}

export default Link
